import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import DefaultModal from './DefaultModal'

interface Props {
  isOpen: boolean
  onClose: () => void
  thorChainEnvironment: string
  ethNetworkEnvironment: string
}

const StagenetWarningModal: React.FC<Props> = ({
  isOpen,
  onClose,
  thorChainEnvironment,
  ethNetworkEnvironment,
}) => {
  return (
    <DefaultModal
      isOpen={isOpen}
      onClose={onClose}
      isLoading={false}
      title="⚠️ Testnet Environment Warning"
      maxW="500px"
    >
      <div className="p-6 space-y-4">
        <div className="flex items-center space-x-3 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg">
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="text-yellow-600 dark:text-yellow-400 text-xl"
          />
          <div>
            <p className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
              You are currently using testnet environments:
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex justify-between items-center p-3 bg-gray-50 dark:bg-gray-800 rounded-md">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              ThorChain:
            </span>
            <span className="text-sm font-semibold text-orange-600 dark:text-orange-400">
              {thorChainEnvironment.toUpperCase()}
            </span>
          </div>

          <div className="flex justify-between items-center p-3 bg-gray-50 dark:bg-gray-800 rounded-md">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Ethereum Network:
            </span>
            <span className="text-sm font-semibold text-orange-600 dark:text-orange-400">
              {ethNetworkEnvironment.toUpperCase()}
            </span>
          </div>
        </div>

        <div className="p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
          <p className="text-sm text-blue-800 dark:text-blue-200">
            <strong>Important:</strong> This means you're interacting with test
            networks. Any transactions will use test tokens and will not affect
            real assets. Make sure this is intended for your testing purposes.
          </p>
        </div>

        <div className="pt-4">
          <button onClick={onClose} className="w-full button">
            I Understand
          </button>
        </div>
      </div>
    </DefaultModal>
  )
}

export default StagenetWarningModal
